import { useHistory, useRouteMatch } from 'react-router-dom';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { isDate, isNil } from 'lodash/fp';
import { getUrlParams, setUrlParams } from '../../../utils/helpers/urlParams';

type ParamType = boolean | string | null | number | Date | string | string[];

const useSearchParams = () => {
    const history = useHistory();
    const { isExact } = useRouteMatch();

    const [showInProcess, setShowInProcess] = useState<boolean>(false);

    const handleUrlParamSet = <T extends ParamType>(setState: Dispatch<SetStateAction<T>>) =>
        (paramObj: Record<string, ParamType>) => {
            if (isExact) {
                const paramName = Object.keys(paramObj)[0];
                const param = paramObj[paramName];
                setState(param as T);
                const finalParam = isDate(param) ? param.toISOString() : param;
                const newUrlParams = setUrlParams(history.location.search, {
                    [paramName]: isNil(finalParam) ? '' : finalParam || '',
                });

                history.push({ search: newUrlParams.toString() });
            }
        };

    useEffect(() => {
        if (isExact) {
            const [
                showInProcessParam,
            ] = getUrlParams({
                searchString: history.location.search,
                params: ['showInProcess'],
            });

            const newShowInProcess = showInProcessParam === 'true';
            setShowInProcess(newShowInProcess);

            const newUrlParams = setUrlParams(history.location.search, {
                showInProcess: newShowInProcess ? 'true' : 'false',
            });

            history.push({ search: newUrlParams.toString() });
        }
    // eslint-disable-next-line
    }, [isExact]);

    const handleSetShowInProcess = (p: ParamType) => handleUrlParamSet(setShowInProcess)({ showInProcess: p });

    return {
        showInProcess, setShowInProcess: handleSetShowInProcess,
    };
};

export default useSearchParams;
